import * as constants from "../constants/cinemaShowtimesConstants";
import actionCreators from "../../../itemList/actions/tabbedMoviesActionCreators";

export default actionCreators(constants);
